<template>
<!-- 为灵活信号设置页面提供确认操作的modal页面，在需要跟后端交互的页面中添加一个执行+进度条展示进度的操作 -->
  <div>
    <Row>
      <Modal
        v-model="m_open_modal_switch"
        :title="this.get_modal_title()"
        :loading="loading_status"
        @on-ok="set_ok"
        @on-cancel="set_cancel"
        @on-visible-change="set_changed"
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span>{{ this.get_modal_title() }}</span>
        </p>
        <Row>
          <Col span="20" offset="2">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="执行信息">
                <Input v-model="input_value" readonly style="border:none" type="textarea"/>
              </FormItem>
              <FormItem label="执行进度">
                <Progress :percent="task_progress" :status="task_progress_active" 
                  :stroke-color="['#108ee9', '#87d068']"/>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>
<script>

export default {
  name: "flexible_render_modal_view_confirm",
  data() {
    return {
      timer: null,
      task_progress:0,
      task_progress_active:"normal",
      input_value:"等待最新信息",
      m_open_modal_switch:false,
      loading_status:false,
    }
  },
  props: {
    // 向后端发端的data
    params: {
      type: Object,
    },
    open_modal_switch: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
    }
  },
  methods:{
    setTimer: function (interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.update_progress()
        }, interval);
      }
    },
    update_progress: async function() {
      if (this.task_progress_active == "wrong") {
        return null
      }
      if (Number(this.task_progress) >= 100) {
        return null
      }
      // 更新进度条进度
      var formData = new FormData();
      formData.append("mode", "get_task_progress");
      formData.append("uuid", this.params["uuid"]);
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/flexible_strategy",
          method: "POST",
          data: formData,
        })
      if (data != null) {
        this.task_progress_active = data["status"]
        this.task_progress = data["percent"]
        this.input_value = data["text"]
      }
    },
    get_modal_title() {
      return this.title
    },
    set_cancel() {
      this.$emit("modal_confirm_click", {
        "mode":"cancel",
      })
    },
    set_ok() {
      this.$emit("modal_confirm_click", {
        "mode":"ok",
      })
    },
    set_changed(value) {
      if (value == false) {
        clearInterval(this.timer);
        this.timer = null;
      } else {
        clearInterval(this.timer);
        this.timer = null;
        // 刷新频率
        this.setTimer(1 * 1000);
      }
    },
  },
  mounted: function() {
    
  },
  watch: {
    open_modal_switch(old_value) {
      // 避免直接由内部修改props的情况
      this.m_open_modal_switch = this.open_modal_switch
      if (this.m_open_modal_switch == true) {
        this.task_progress = 0
        this.task_progress_active = "normal"
        this.input_value = "等待最新信息"
      } else {

      }
    },
  }
}
</script>
<style scoped>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
 /deep/.ivu-input{
  border: none!important;
}
</style>